var ClickAndReserve = /* @__PURE__ */ ((ClickAndReserve2) => {
  ClickAndReserve2["STOCK"] = "STOCK";
  ClickAndReserve2["STOCK_RESERVATION"] = "STOCK_RESERVATION";
  ClickAndReserve2["STOCK_RESERVATION_APPOINTMENT"] = "STOCK_RESERVATION_APPOINTMENT";
  return ClickAndReserve2;
})(ClickAndReserve || {});
export {
  ClickAndReserve
};
//# sourceMappingURL=feature-config.enum.js.map
